import React, { useEffect, useState } from 'react'
import MainBox from '../MainBox/index'
import PassResetEmail from '../passReset/index'
import CodeInput from '../CodeInput/index'
import ResetPassword from '../CodeInput/indexresset'
import RegisterScreen from '../Register/index'
import ResetSuccess from '../SuccessMsg/indexsucess'
import {
  Container,
  LeftSide,
  RightSide,
  LeftOverlay,
  LeftTexts,
  LeftLogoImg,
} from './style'
import FactoryImage from './img-login/imagemordeno.png'
import FMark from './img-login/itens img.png'
import ApiService from '../../../services/ApiService'

interface LoginInfo {
  email: string
  password: string
}

const LoginScreen = () => {
  const [page, setPage] = useState<string>('Main')
  const [maintenanceActive, setMaintenanceActive] = useState(false)
  const [maintenanceMessage, setMaintenanceMessage] = useState<string | null>(null)

  const [userlogin, setUserlogin] = useState<LoginInfo>({
    email: '',
    password: '',
  })

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('maintenance') === 'true') {
      setMaintenanceActive(true)
      ApiService.systemSettings.getMaintenanceStatus()
        .then((res) => {
          if (res.data?.maintenanceMessage) {
            setMaintenanceMessage(res.data.maintenanceMessage)
          }
        })
        .catch(() => {})
    }
  }, [])

  const showMaintenance = (message: string | null) => {
    setMaintenanceMessage(message)
    setMaintenanceActive(true)
  }

  if (page === 'PassReset') {
    return <PassResetEmail setPage={setPage} />
  }

  if (page === 'Register') {
    return <RegisterScreen setPage={setPage} />
  }

  if (page === 'CodeInput') {
    return <CodeInput setPage={setPage} />
  }

  if (page === 'ResetPassword') {
    return <ResetPassword setPage={setPage} />
  }

  if (page === 'ResetSuccess') {
    return <ResetSuccess setPage={setPage} />
  }

  return (
    <Container>
      <LeftSide style={{ backgroundImage: `url(${FactoryImage})` }}>
        <LeftOverlay />
        <LeftTexts>
          <LeftLogoImg src={FMark} alt='Logo Ordeno' />

          <h1>
            Gestão fácil,
            <br />
            resultados reais.
          </h1>
          <p>Tudo que sua fábrica precisa, em um só lugar.</p>
        </LeftTexts>
      </LeftSide>

      <RightSide>
        {maintenanceActive ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '48px 32px',
            maxWidth: '420px',
            textAlign: 'center',
            fontFamily: "'Roboto', system-ui, sans-serif",
          }}>
            <div style={{
              width: '64px',
              height: '64px',
              borderRadius: '50%',
              backgroundColor: '#fef2f2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '24px',
            }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
              </svg>
            </div>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 600, color: '#1e293b', margin: '0 0 12px 0' }}>
              Sistema em Manutenção
            </h2>
            <p style={{ fontSize: '1rem', color: '#64748b', lineHeight: 1.6, margin: 0 }}>
              {maintenanceMessage || 'Não é possível utilizar o sistema no momento. Por favor, tente novamente mais tarde.'}
            </p>
          </div>
        ) : (
          page === 'Main' && (
            <MainBox
              setUserlogin={setUserlogin}
              setPage={setPage}
              onMaintenance={showMaintenance}
            />
          )
        )}
      </RightSide>
    </Container>
  )
}

export default LoginScreen
